import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/OutsideGuestReport/SearchReport",
    method: "get",
    params
  });
}
export function getColumns(params) {
  return request({
    url: "/OutsideGuestReport/GetReportHeader",
    method: "get",
    params
  });
}
